import { Row } from "react-stately";

import type { HTMLAttributes, JSX } from "react";
import type { RowProps } from "react-stately";

export type TableRowProps<T = object> = RowProps<T> &
  Omit<HTMLAttributes<HTMLTableRowElement>, keyof RowProps<T>>;

export const TableRow = Row as (props: TableRowProps) => JSX.Element;
